var createStylesheet = function(chunkId, fullhref, resolve, reject) {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	var onLinkComplete = function(event) {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;

	document.head.appendChild(linkTag);
	return linkTag;
};
var findStylesheet = function(href, fullhref) {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = function(chunkId) {
	return new Promise(function(resolve, reject) {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	2143: 0
};

__webpack_require__.f.miniCss = function(chunkId, promises) {
	var cssChunks = {"78":1,"117":1,"161":1,"294":1,"391":1,"423":1,"518":1,"586":1,"657":1,"830":1,"856":1,"878":1,"946":1,"1133":1,"1281":1,"1439":1,"1446":1,"1515":1,"1559":1,"2088":1,"2292":1,"2636":1,"2924":1,"2953":1,"3069":1,"3196":1,"3438":1,"3664":1,"3739":1,"3784":1,"3837":1,"3946":1,"3990":1,"4106":1,"4190":1,"4394":1,"4404":1,"4522":1,"4890":1,"5324":1,"5352":1,"5388":1,"5514":1,"5585":1,"5593":1,"5639":1,"5740":1,"5841":1,"5861":1,"6154":1,"6170":1,"6177":1,"6222":1,"6384":1,"6412":1,"6754":1,"6789":1,"6896":1,"6900":1,"6951":1,"7311":1,"7438":1,"7561":1,"7631":1,"7650":1,"7735":1,"8023":1,"8062":1,"8114":1,"8216":1,"8247":1,"8286":1,"8458":1,"8700":1,"8822":1,"8914":1,"8935":1,"9067":1,"9077":1,"9263":1,"9440":1,"9497":1,"9575":1,"9836":1,"9859":1,"9896":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(function() {
			installedCssChunks[chunkId] = 0;
		}, function(e) {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr